export default __webpack_public_path__ + "static/media/TaskListTabNavigation.206e8182.PNG";